import moment from 'moment'
import { fetchWithToken } from '@hublot-io/core-api/client'
import config from '../utils/apiUtils'

export const ObjectifService = {
  setStock(clientId, stock) {
    const parsedStock = {
      ...stock,
      lastUpdate: moment().format('YYYY-MM-DD HH:mm:ss'),
    }
    return fetchWithToken(`${config().syncService}/stock`, { method: 'PUT', body: JSON.stringify([parsedStock]) })
  },
  getObjectif(clientId, dateStart, dateEnd) {
    return fetchWithToken(`${config().objectifLegacyService}/${clientId}?dateStart=${dateStart}&dateEnd=${dateEnd}`, { method: 'GET' })
      .then((response) => response.json())
      .then((json) => json)
  },
  getObjectifDetail(clientId, dateStart, dateEnd) {
    return fetchWithToken(`${config().objectifLegacyService}/${clientId}?dateStart=${dateStart}&dateEnd=${dateEnd}&detail=all`, { method: 'GET' })
      .then((response) => response.json())
      .then((json) => json)
  },
  getStock(clientId, date) {
    return fetchWithToken(`${config().objectifLegacyService}/stock/${date}?clientid=${clientId}`, { method: 'GET' })
      .then((response) => response.json())
      .then((json) => json)
  },
}
